var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2399 4.42667C13.0788 5.26586 13.6501 6.33496 13.8814 7.49879C14.1128 8.66263 13.9939 9.86893 13.5397 10.9652C13.0855 12.0614 12.3165 12.9984 11.3298 13.6576C10.3432 14.3168 9.18319 14.6686 7.99659 14.6686C6.80998 14.6686 5.65002 14.3168 4.66337 13.6576C3.67671 12.9984 2.90768 12.0614 2.4535 10.9652C1.99931 9.86893 1.88038 8.66263 2.11173 7.49879C2.34308 6.33496 2.91433 5.26586 3.75325 4.42667",
    stroke: "#8E6DFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.33333V8",
    stroke: "#8E6DFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnect);
export default __webpack_public_path__ + "static/media/disconnect.dd0a67fd09ac0f697a0a7f19275ce9a0.svg";
export { ForwardRef as ReactComponent };